import {component} from '@reduct/component';
import Pikaday from 'pikaday';

import { moment, getMonths, getWeekDays, getWeekDaysShort } from '../../Utils/I18N/';
import app from '../../assembler';

@component()
class DatePicker {
	constructor() {
		const pikaday = new Pikaday({
			field: this.getElement(),
			format: moment.localeData()._longDateFormat.L,
			container: this.getElement().parentNode,

			i18n: {
				months: getMonths(),
				weekdays: getWeekDays(),
				weekdaysShort: getWeekDaysShort()
			},

			onSelect: function () {
				el.setAttribute('data-actual', pikaday.getMoment().format('YYYY-MM-DD'));
			}
		});
	}
}

app.register(DatePicker, 'DatePicker');
